var exports = {
  "N": "x804f0401--60413b--element",
  "c": "x804f0401--60413b--element--inline",
};

module.exports = exports;
